import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginUser } from '../../services/services';
import Navbar from '../../components/common/Navbar';
import Footer from '../../components/common/Footer';
import { Helmet } from 'react-helmet';
import { message } from 'antd';
import { EyeOutlined, EyeInvisibleOutlined } from '@ant-design/icons';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
   const [showPassword, setShowPassword] = useState(false);
  const [remember, setRemember] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const res = await loginUser({ email, password });

      // Save user data to localStorage
     localStorage.setItem('token', res.token);
localStorage.setItem(
  'user',
  JSON.stringify({
    ...res.user,
    user_type: res.user.type
  })
);

      
      // Set remember me functionality
      if (remember) {
        localStorage.setItem('rememberedEmail', email);
      } else {
        localStorage.removeItem('rememberedEmail');
      }

      // Show success message
      message.success(`Welcome back, ${res.user.name || 'User'}!`);
      
      // Redirect logic
      if (res.user.type === 'admin') {
        navigate('/admin/dashboard'); // Special admin dashboard
      } else {
        navigate('/dashboard'); // Unified dashboard for other users
      }

    } catch (err) {
      const errorMsg = err.response?.data?.message || 'Login failed. Please try again.';
      setError(errorMsg);
      message.error(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Login - Startup Business Partners</title>
      </Helmet>
      <Navbar />
      <br />
      <br />
      <div className="login-form d-flex align-items-center">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 offset-lg-2 col-xl-6 offset-xl-3">
              <div className="form-wrapper">
                <div className="card card-shadow">
                  <div className="card-header">
                    <br />
                    <h4 className="text-center">Sign In Here!</h4>
                  </div>
                  <div className="card-body">
                    {error && <div className="alert alert-danger">{error}</div>}
                    <form onSubmit={handleSubmit}>
                      <div className="form-group">
                        <input
                          type="email"
                          placeholder="Email Address"
                          className="form-control"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          required
                        />
                      </div>
        <div style={{ position: "relative" }}>
      <input
        type={showPassword ? "text" : "password"}
        placeholder="Password"
        style={{ paddingRight: "40px" }} // space for icon
        value={password}
        onChange={(e) => setPassword(e.target.value)}
         className="form-control pr-10"
        required
      />

      <span
        onClick={() => setShowPassword(!showPassword)}
        style={{
          position: "absolute",
          right: "10px",
          top: "50%",
          transform: "translateY(-50%)",
          cursor: "pointer",
          color: "#888",
        }}
      >
        {showPassword ? <EyeInvisibleOutlined /> : <EyeOutlined />}
      </span>
    </div>
                      <div className="form-action d-flex justify-content-between">
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="rememberMe"
                            checked={remember}
                            onChange={(e) => setRemember(e.target.checked)}
                          />
                          <label className="form-check-label" htmlFor="rememberMe">
                            Remember Me
                          </label>
                        </div>
  
                       
                        
                         
                        <a href="/forgot-password" className="color-secondary">
                          Lost your password?
                        </a>
  
                          
                       
                      </div>
<div className="form-group text-center m-bottom-20">
  <p><a href="/termscondition" target="_blank" rel="noopener noreferrer">
                            Terms and Conditions</a>
                          </p>
                          </div>
                      <div className="form-group text-center m-bottom-20">
                        <button
                          className="btn btn-secondary"
                          type="submit"
                          disabled={loading}
                        >
                          {loading ? 'Logging in...' : 'Sign In'}
                        </button>
                      </div>
                    </form>
                    <p className="text-center m-bottom-25">
                      Don't you have an account? <a href="/register">Register</a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
  
          </div>
        </div>
      </div>
      <Footer />
      <style jsx>{`
        .form-check-input {
          margin-top: 0.2rem;
          margin-right: 0.5rem;
        }
        .form-check-label {
          cursor: pointer;
        }
      `}</style>
    </>
  );
}

export default Login;